import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalContactsPageComponent } from './internal-contacts-page.component';
import { AccordionModule } from '../../../../components/accordion/accordion.module';
import { ModalManagerSelectModule } from '../../../../components/modal-manager-select/modal-manager-select.module';
import { SettingsCommonModule } from '../../../../settings-common.module';

@NgModule({
  imports: [
    CommonModule,
    SettingsCommonModule,
    AccordionModule,
    ModalManagerSelectModule,
  ],
  declarations: [InternalContactsPageComponent],
  exports: [InternalContactsPageComponent]
})
export class InternalContactsPageModule {
}
